import FeeTypeUndertableCommission from './FeeTypeUndertableCommission';

export default FeeTypeUndertableCommission;